<template>
  <div class="app-container" id="courseList">
    <el-radio-group @change="handleClick" v-model="listQuery.type">
      <el-radio border label="0" size="small" class="myRadio"
        >全部({{ courseSum.qb }})</el-radio
      >
      <el-radio border label="1" size="small" class="myRadio"
        >待我评审({{ courseSum.dwps }})</el-radio
      >
      <el-radio border label="2" size="small" class="myRadio"
        >我已评审({{ courseSum.wyps }})</el-radio
      >
      <el-radio border label="3" size="small" class="myRadio"
        >我参与({{ courseSum.wcy }})</el-radio
      >
      <el-radio border label="4" size="small" class="myRadio"
        >我辅导({{ courseSum.wfd }})</el-radio
      >
    </el-radio-group>
    <el-button
      :icon="areaStatus == 1 ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
      size="small"
      class="filter-item"
      style="margin-left: 15px"
      @click="handleToggleAeraStatus"
      >{{ areaStatus == 1 ? "收起" : "展开" }}</el-button
    >
    <div class="mycontainer">
      <el-form
        ref="queryForm"
        :model="listQuery"
        :inline="true"
        v-if="areaStatus"
        label-width="80px"
      >
        <el-form-item label="课题属性" prop="ktsx">
          <el-select
            ref="ktsx"
            v-model="listQuery.ktsx"
            placeholder="请选择课题属性"
            clearable
            filterable
            size="small"
            style="width: 170px"
            class="filter-item"
          >
            <el-option
              v-for="item in ktsxOptions"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="正式临时" prop="zsls">
          <el-select
            ref="zsls"
            v-model="listQuery.zsls"
            clearable
            filterable
            size="small"
            style="width: 170px"
            class="filter-item"
          >
            <el-option
              v-for="item in zslsOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="年份" prop="nf">
          <el-select
            ref="nf"
            v-model="listQuery.nf"
            placeholder="请选择年份"
            clearable
            filterable
            size="small"
            style="width: 170px"
            class="filter-item"
          >
            <el-option
              v-for="item in nfOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="归属部门" prop="gsbm">
          <el-select
            ref="gsbm"
            v-model="listQuery.gsbm"
            placeholder="请选择归属部门"
            clearable
            filterable
            size="small"
            style="width: 170px"
            class="filter-item"
          >
            <el-option
              v-for="item in bmOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="所属阶段" prop="ssjd">
          <el-select
            ref="ssjd"
            v-model="listQuery.ssjd"
            placeholder="请选择所属阶段"
            clearable
            filterable
            size="small"
            style="width: 170px"
            class="filter-item"
          >
            <el-option label="立项申请" value="1"></el-option>
            <el-option label="立项评审" value="2"></el-option>
            <el-option label="中期检查" value="3"></el-option>
            <el-option label="结项评审" value="4"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否撤销" prop="sfcx">
          <el-select
            ref="sfcx"
            v-model="listQuery.sfcx"
            placeholder="请选择是否撤销"
            clearable
            filterable
            size="small"
            style="width: 170px"
            class="filter-item"
          >
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否立项" prop="sflx">
          <el-select
            ref="sfjx"
            v-model="listQuery.sflx"
            placeholder="请选择是否立项"
            clearable
            filterable
            size="small"
            style="width: 170px"
            class="filter-item"
          >
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否结项" prop="sfjx">
          <el-select
            ref="sfjx"
            v-model="listQuery.sfjx"
            placeholder="请选择是否结项"
            clearable
            filterable
            size="small"
            style="width: 170px"
            class="filter-item"
          >
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="评委委员" prop="pswy">
          <el-select
            multiple
            collapse-tags
            ref="pswy"
            v-model="listQuery.pswy"
            placeholder="请输选择委委员"
            clearable
            filterable
            size="small"
            style="width: 170px"
            class="filter-item"
          >
            <el-option
              v-for="item in pswyOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="导师" prop="ktds">
          <el-select
            multiple
            collapse-tags
            ref="ktds"
            v-model="listQuery.ktds"
            placeholder="请选择导师"
            clearable
            filterable
            size="small"
            style="width: 170px"
            class="filter-item"
          >
            <el-option
              v-for="item in ktdsOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="负责人" prop="fzr">
          <el-select
            multiple
            collapse-tags
            ref="fzr"
            v-model="listQuery.fzr"
            placeholder="请选择负责人"
            clearable
            filterable
            size="small"
            style="width: 170px"
            class="filter-item"
          >
            <el-option
              v-for="item in fzrOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="课题名称" prop="ktmc">
          <el-input
            v-model="listQuery.ktmc"
            placeholder="请输入课题名称"
            clearable
            size="small"
            style="width: 170px"
          />
        </el-form-item>

        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="getList"
            >查询</el-button
          >

          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            @click="handleAddCourse(1)"
            style="
              margin-left: 15px;
              color: #fff;
              background-color: #1c84c6;
              border-color: #1c84c6;
            "
            >临时课题</el-button
          >

          <el-button
            type="primary"
            v-if="user.courseAdmin == 1"
            icon="el-icon-plus"
            size="small"
            @click="handleAddCourse(2)"
            style="
              margin-left: 15px;
              color: #fff;
              background-color: #1c84c6;
              border-color: #1c84c6;
            "
            >管理员录入</el-button
          >

          <el-button
            type="primary"
            icon="el-icon-download"
            size="small"
            @click="handleExport"
            style="
              margin-left: 15px;
              color: #fff;
              background-color: #f8ac59;
              border-color: #f8ac59;
            "
            >导出</el-button
          >
          <el-button
            icon="el-icon-refresh"
            size="small"
            class="filter-item"
            style="margin-left: 15px"
            @click="reset"
            >重置</el-button
          >
        </span>
      </el-form>
    </div>
    <div style="margin-top: 10px">
      <el-table
        :max-height="height"
        v-loading="course.courseList.list.listLoading"
        :data="course.courseList.list.item"
        fit
        highlight-current-row
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          fixed
          label="操作"
          min-width="150"
          align="center"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <el-dropdown size="small">
              <el-button type="primary" size="small">
                操作列
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <div @click="handleView(scope.row)">
                    <el-button type="text" size="small">课题结果</el-button>
                  </div>
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="scope.row.fwgl == 1 || scope.row.fwcy == 1"
                >
                  <div @click="handleToLxsq(scope.row)">
                    <el-button type="text" size="small">立项申请</el-button>
                  </div>
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="
                    (scope.row.fwgl == 1 ||
                      scope.row.fwps1.indexOf('3_') > -1) &&
                    scope.row.courseprop != '3' &&
                    scope.row.cstep == 3 &&
                    scope.row.cproject != '2' &&
                    scope.row.iftwo != 1 &&
                    scope.row.cproject != '3'
                  "
                >
                  <div @click="handleToLxps(scope.row)">
                    <el-button type="text" size="small">立项评审</el-button>
                  </div>
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="
                    scope.row.iftwo == 1 &&
                    (scope.row.fwgl == 1 || scope.row.fwps2.indexOf('3_') > -1)
                  "
                >
                  <div @click="handleToLxpsSecond(scope.row)">
                    <el-button type="text" size="small">立项二次评审</el-button>
                  </div>
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="
                    (scope.row.fwgl == 1 || scope.row.fwcy == 1) &&
                    scope.row.courseprop !== '3' &&
                    scope.row.group !== '3' &&
                    scope.row.cstep >= 4
                  "
                >
                  <div @click="handleToZqjc(scope.row)">
                    <el-button type="text" size="small">中期检查申请</el-button>
                  </div>
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="
                    (scope.row.fwgl == 1 ||
                      scope.row.fwps1.indexOf('4_') > -1) &&
                    scope.row.group !== '3' &&
                    scope.row.courseprop !== '3' &&
                    scope.row.cstep == 4
                  "
                >
                  <!--   scope.row.iftwo != 1 && -->
                  <div @click="handleToZqjcps(scope.row)">
                    <el-button type="text" size="small">中期检查评审</el-button>
                  </div>
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="
                    (scope.row.fwgl == 1 || scope.row.fwcy == 1) &&
                    scope.row.group != '3' &&
                    scope.row.cstep >= 5
                  "
                >
                  <div @click="handleToJxsq(scope.row)">
                    <el-button type="text" size="small">结项申请</el-button>
                  </div>
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="
                    (scope.row.fwgl == 1 ||
                      scope.row.fwps1.indexOf('15_') > -1) &&
                    scope.row.group === '2' &&
                    scope.row.cstep == 15
                  "
                >
                  <div @click="handleToJxcs(scope.row)">
                    <el-button type="text" size="small">结项初审</el-button>
                  </div>
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="
                    (scope.row.fwgl == 1 ||
                      scope.row.fwps1.indexOf('6_') > -1) &&
                    ((scope.row.cstep == 6 && scope.row.group == 2) ||
                      ((scope.row.group == 1 || scope.row.group == 3) &&
                        scope.row.cstep == 6))
                  "
                >
                  <div @click="handleToJxps(scope.row)">
                    <el-button type="text" size="small">结项评审</el-button>
                  </div>
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="
                    (scope.row.fwgl == 1 || scope.row.fwcy == 1) &&
                    scope.row.group == '1' &&
                    scope.row.sfycjx == 1
                  "
                >
                  <div @click="handleToYqjxsq(scope.row)">
                    <el-button type="text" size="small">延期结项申请</el-button>
                  </div>
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="
                    (scope.row.fwgl == 1 ||
                      scope.row.fwps1.indexOf('13_') > -1) &&
                    scope.row.group !== '2' &&
                    scope.row.cstep == 13 &&
                    scope.row.sfycjx == 1
                  "
                >
                  <div @click="handleToYqjxps(scope.row)">
                    <el-button type="text" size="small">延期结项评审</el-button>
                  </div>
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="
                    (scope.row.fwgl == 1 ||
                      scope.row.fwps1.indexOf('16_') > -1) &&
                    scope.row.group == '3' &&
                    scope.row.cstep > 6
                  "
                >
                  <div @click="handleToZlpf(scope.row)">
                    <el-button type="text" size="small">质量评分</el-button>
                  </div>
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="
                    (scope.row.fwgl == 1 || scope.row.fwcy == 1) &&
                    scope.row.group !== '2' &&
                    scope.row.cstep >= 4
                  "
                >
                  <div @click="handleToYqjx(scope.row)">
                    <el-button type="text" size="small">延迟结项</el-button>
                  </div>
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="scope.row.fwgl == 1 || scope.row.fwcy == 1"
                >
                  <div @click="handleToKtcx(scope.row.id)">
                    <el-button type="text" size="small">课题撤销</el-button>
                  </div>
                </el-dropdown-item>

                <el-dropdown-item
                  v-if="
                    (scope.row.fwgl == 1 ||
                      scope.row.fwcy == 1 ||
                      scope.row.fwfd == 1) &&
                    scope.row.cstep >= 4 &&
                    scope.row.group !== '3'
                  "
                >
                  <div @click="handletrackMonth(scope.row.id)">
                    <el-button type="text" size="small">月报追踪</el-button>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
        <el-table-column
          fixed
          label="课题编号"
          align="left"
          prop="id"
          min-width="110px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <label :class="scope.row.ifcx == '1' ? 'red_label' : ''">{{
              scope.row.id
            }}</label>
          </template>
        </el-table-column>
        <el-table-column
          fixed
          label="课题名称"
          align="left"
          prop="name"
          min-width="250px"
          :show-overflow-tooltip="false"
        >
          <template slot-scope="scope">
            <label :class="scope.row.ifcx == '1' ? 'red_label' : ''">{{
              scope.row.name
            }}</label>
          </template>
        </el-table-column>
        <el-table-column
          label="负责人"
          align="left"
          prop="leader"
          min-width="80px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="课题成员"
          align="left"
          prop="members"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="评审委员"
          align="left"
          prop="judges"
          min-width="120px"
          :show-overflow-tooltip="false"
        >
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content">
                <div v-html="scope.row.judges"></div>
              </div>
              <!-- <div class="list_judges" v-html="scope.row.judges"></div> -->
              <div class="list_judges">{{ scope.row.judges }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          label="课题导师"
          align="left"
          prop="teacher"
          min-width="80px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="归属部门"
          align="left"
          prop="bmmc"
          min-width="110px"
          :show-overflow-tooltip="true"
        />

        <el-table-column
          label="课题属性"
          align="left"
          prop="gname"
          min-width="120px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div>{{ `${scope.row.gname}(${scope.row.attr})` }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="课题类型"
          align="left"
          prop="type"
          min-width="80px"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="项目类型"
          align="left"
          prop="project"
          min-width="80px"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="立项申请"
          align="center"
          prop="h1"
          min-width="150px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div v-html="scope.row.h1"></div>
          </template>
        </el-table-column>
        <el-table-column
          label="月报跟踪"
          align="center"
          prop="h2"
          min-width="150px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div v-html="scope.row.h2"></div>
          </template>
        </el-table-column>
        <el-table-column
          label="立项评审"
          align="center"
          prop="h3"
          min-width="150px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div v-html="scope.row.h3"></div>
          </template>
        </el-table-column>
        <el-table-column
          label="中期检查"
          align="center"
          prop="h4"
          min-width="150px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div v-html="scope.row.h4"></div>
          </template>
        </el-table-column>
        <el-table-column
          label="结项申请"
          align="center"
          prop="h5"
          min-width="150px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div v-html="scope.row.h5"></div>
          </template>
        </el-table-column>
        <el-table-column
          label="结项评审"
          align="center"
          prop="h6"
          min-width="150px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div v-html="scope.row.h6"></div>
          </template>
        </el-table-column>
        <el-table-column
          label="成果分享"
          align="center"
          prop="h7"
          min-width="150px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div v-html="scope.row.h7"></div>
          </template>
        </el-table-column>
        <el-table-column
          label="奖金报销"
          align="center"
          prop="h8"
          min-width="150px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div v-html="scope.row.h8"></div>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
      <pagination
        v-show="course.courseList.list.count > 0"
        :total="course.courseList.list.count"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.pageSize"
        @pagination="getList"
      />
    </div>
    <!-- 课题录入 -->
    <el-dialog
      :title="addCourseTitle"
      :visible.sync="addCourseDialog"
      width="90%"
      v-if="addCourseDialog"
      :closeOnClickModal="false"
    >
      <AddCourse
        :mxParams="mxParams"
        @getParentForm="getList"
        ref="addCourseForm"
      ></AddCourse>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addCourseDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveAddCourseForm">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 立项申请 -->
    <el-dialog
      title="立项申请"
      :visible.sync="lxsqFormDialog"
      width="90%"
      :closeOnClickModal="false"
      v-if="lxsqFormDialog"
    >
      <LxsqForm
        :mxParams="mxParams"
        @getParentForm="getList"
        ref="lxsqForm"
      ></LxsqForm>
      <span slot="footer" class="dialog-footer">
        <el-button @click="lxsqFormDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveLxsqForm">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 立项评审 -->
    <el-dialog
      title="立项评审"
      :visible.sync="handleLxpsDialog"
      width="90%"
      v-if="handleLxpsDialog"
      :closeOnClickModal="false"
    >
      <HandleLxps
        ref="lxpsForm"
        :mxParams="mxParams"
        @getParentForm="getList"
      ></HandleLxps>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleLxpsDialog = false">取 消</el-button>

        <el-button type="primary" @click="saveLxpsForm">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 立项二次评审 -->
    <el-dialog
      title="立项二次评审"
      :visible.sync="handleLxpsSecondDialog"
      width="90%"
      v-if="handleLxpsSecondDialog"
      :closeOnClickModal="false"
    >
      <HandleLxpsSecond
        ref="lxpsSecondForm"
        :mxParams="mxParams"
        @getParentForm="getList"
      ></HandleLxpsSecond>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleLxpsSecondDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveLxpsSecondForm">保 存</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="课题结果查看"
      :visible.sync="handleResultDialog"
      width="100%"
      top="0"
      v-if="handleResultDialog"
      :closeOnClickModal="false"
      :close-on-press-escape="false"
    >
      <CourseResult
        :mxParams="mxParams"
        @hideResultDialog="hideResultDialog"
      ></CourseResult>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="handleResultDialog = false">确 定</el-button>
      </span>-->
    </el-dialog>
    <el-dialog
      title="中期检查"
      :visible.sync="zqjcFormDialog"
      append-to-body
      width="90%"
      v-if="zqjcFormDialog"
      :close-on-click-modal="false"
    >
      <ZqjcForm
        :mxParams="mxParams"
        ref="zqjcForm"
        @getParentForm="getList"
      ></ZqjcForm>

      <span slot="footer" class="dialog-footer">
        <el-button @click="zqjcFormDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveZqjcForm">保 存</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="中期检查评审"
      :visible.sync="zqjcpsFormDialog"
      append-to-body
      width="90%"
      v-if="zqjcpsFormDialog"
      :close-on-click-modal="false"
    >
      <ZqjcpsForm
        :mxParams="this.mxParams"
        ref="zqjcpsForm"
        @getParentForm="getList"
      ></ZqjcpsForm>
      <span slot="footer" class="dialog-footer">
        <el-button @click="zqjcpsFormDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveZqjcpsForm">保 存</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="课题撤销"
      :visible.sync="handleKtcxDialog"
      width="90%"
      :close-on-click-modal="false"
      v-if="handleKtcxDialog"
    >
      <HandleKtcx
        :mxParams="mxParams"
        ref="ktcxForm"
        @getParentForm="getList"
      ></HandleKtcx>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleKtcxDialog = false">取 消</el-button>
        <el-button
          v-if="
            this.isCancelApply.count1 == 1 &&
            this.isCancelApply.count2 == 0 &&
            this.isCancelApply.count3 == 1
          "
          type="primary"
          @click="delKtcxForm"
          >取消申请</el-button
        >
        <el-button type="primary" @click="saveKtcxForm">保 存</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="结项申请"
      :visible.sync="jxsqFormDialog"
      width="90%"
      v-if="jxsqFormDialog"
      :close-on-click-modal="false"
    >
      <JxsqForm
        :mxParams="mxParams"
        ref="jxsqForm"
        @getParentForm="getList"
      ></JxsqForm>
      <span slot="footer" class="dialog-footer">
        <el-button @click="jxsqFormDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveJxsqForm">保 存</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="延期结项"
      :visible.sync="yqjxFormDialog"
      width="90%"
      v-if="yqjxFormDialog"
      :close-on-click-modal="false"
    >
      <YqjxForm
        :mxParams="mxParams"
        ref="yqjxForm"
        @getParentForm="getList"
      ></YqjxForm>
      <span slot="footer" class="dialog-footer">
        <el-button @click="yqjxFormDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveYqjxForm">保 存</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="结项初审"
      :visible.sync="jxcsFormDialog"
      width="90%"
      v-if="jxcsFormDialog"
      :close-on-click-modal="false"
    >
      <JxcsForm
        :mxParams="mxParams"
        ref="jxcsForm"
        @getParentForm="getList"
      ></JxcsForm>
      <span slot="footer" class="dialog-footer">
        <el-button @click="jxcsFormDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveJxcsForm">保 存</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="结项评审"
      :visible.sync="jxpsFormDialog"
      width="90%"
      v-if="jxpsFormDialog"
      :close-on-click-modal="false"
    >
      <JxpsForm
        :mxParams="mxParams"
        ref="jxpsForm"
        @getParentForm="getList"
      ></JxpsForm>
      <span slot="footer" class="dialog-footer">
        <el-button @click="jxpsFormDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveJxpsForm">保 存</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="延期结项评审"
      :visible.sync="yqjxpsFormDialog"
      width="90%"
      v-if="yqjxpsFormDialog"
      :close-on-click-modal="false"
    >
      <YqjxpsForm
        :mxParams="mxParams"
        ref="yqjxpsForm"
        @getParentForm="getList"
      ></YqjxpsForm>
      <span slot="footer" class="dialog-footer">
        <el-button @click="yqjxpsFormDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveYqjxpsForm">保 存</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="延期结项申请"
      :visible.sync="yqjxsqFormDialog"
      width="90%"
      v-if="yqjxsqFormDialog"
      :close-on-click-modal="false"
    >
      <YqjxsqForm
        :mxParams="mxParams"
        ref="yqjxsqForm"
        @getParentForm="getList"
      ></YqjxsqForm>
      <span slot="footer" class="dialog-footer">
        <el-button @click="yqjxsqFormDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveYqjxsqForm">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 质量评分 -->
    <el-dialog
      title="质量评分"
      :visible.sync="handleZlpfDialog"
      width="90%"
      v-if="handleZlpfDialog"
      :closeOnClickModal="false"
    >
      <HandleZlpf
        ref="zlpfForm"
        :mxParams="mxParams"
        @getParentForm="getList"
      ></HandleZlpf>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleZlpfDialog = false">取 消</el-button>

        <el-button type="primary" @click="saveZlpfForm">保 存</el-button>
      </span>
    </el-dialog>

    <trackMonth v-if="OpenTrackMonth" ref="trackMonthRef"></trackMonth>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Pagination from "@/components/Pagination";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { formatMomentDate } from "@/utils/utils";
import { getDictData } from "@/api/common.js";
import {
  getCourseQueryCondition,
  getCourseSum,
  getCourseList,
  exportCourse,
  isCancelApply,
} from "@/api/course.js";
import LxsqForm from "./courseLxsqForm/lxsqForm.vue";
import HandleLxps from "./courseLxpsForm/handleLxps.vue";
import HandleLxpsSecond from "./courseLxpsForm/handleLxpsSecond.vue";
import CourseResult from "./result.vue";
import ZqjcForm from "./courseZqjcForm/zqjcForm.vue";
import ZqjcpsForm from "./courseZqjcForm/zqjcpsForm.vue";
import JxsqForm from "./courseJxsqForm/jxsqForm.vue";
import YqjxsqForm from "./courseJxsqForm/yqjxsqForm.vue";
import HandleKtcx from "./courseKtcxForm/handleKtcx.vue";
import AddCourse from "./courseForm/addCourse.vue";
import trackMonth from "@/views/trackMonth/index.vue";
import JxpsForm from "./courseJxpsForm/handleJxps.vue";
import JxcsForm from "./courseJxpsForm/handleJxcs.vue";
import YqjxpsForm from "./courseJxpsForm/handleYqjxps.vue";
import YqjxForm from "./courseJxsqForm/yqjxForm.vue";
import HandleZlpf from "./courseZlpfForm/handleZlpf.vue";

export default {
  // 列表分页
  components: {
    Pagination,
    Treeselect,
    LxsqForm,
    HandleLxps,
    HandleZlpf,
    HandleLxpsSecond,
    CourseResult,
    ZqjcForm,
    ZqjcpsForm,
    HandleKtcx,
    AddCourse,
    trackMonth,
    JxsqForm,
    YqjxsqForm,
    JxpsForm,
    JxcsForm,
    YqjxpsForm,
    YqjxForm,
  },
  data() {
    return {
      type: "0",
      height: 100,
      courseSum: {
        qb: 0,
        dwps: 0,
        wyps: 0,
        wcy: 0,
        wfd: 0,
      },
      sxjdOptions: [],
      listQuery: {
        type: "0",
        ktsx: null,
        zsls: null,
        nf: null,
        gsbm: null,
        ssjd: null,
        sfcx: null,
        sflx: null,
        sfjx: null,
        pswy: null,
        ktds: null,
        fzr: null,
        ktmc: null,
        page: 1,
        pageSize: 50,
      },
      ktsxOptions: [],
      nfOptions: [],
      ssjdOptions: [],
      pswyOptions: [],
      ktdsOptions: [],
      fzrOptions: [],
      bmOptions: [],
      zslsOptions: [
        {
          value: "1",
          label: "正式课题",
        },
        {
          value: "3",
          label: "临时课题",
        },
      ],

      total: 0,
      list: [
        {
          id: "",
        },
      ],

      dialogLxsq: false,
      lxsqFormDialog: false,
      handleLxpsDialog: false,
      handleLxpsSecondDialog: false,
      handleResultDialog: false,
      zqjcFormDialog: false,
      zqjcpsFormDialog: false,
      mxParams: {
        id: null,
        txlx: null,
      },
      handleKtcxDialog: false,
      handleZlpfDialog: false,
      addCourseTitle: null,
      addCourseDialog: false,
      OpenTrackMonth: false,
      jxsqFormDialog: false,
      yqjxFormDialog: false,
      yqjxsqFormDialog: false,
      jxpsFormDialog: false,
      jxcsFormDialog: false,
      yqjxpsFormDialog: false,
      isCancelApply: {
        count1: null,
        count2: null,
        count3: null,
      },
      areaStatus: 1,
      defaulContainerH: null,
    };
  },
  computed: {
    ...mapGetters(["course", "user"]),
  },
  created() {
    if (this.$route.params) {
      this.listQuery = { ...this.listQuery, ...this.$route.params };
      this.listQuery.ssjd ? +this.listQuery.ssjd : this.listQuery.ssjd;
    }
    if (!this.user.xm) {
      this.$store.dispatch("common/fetchUserInfoAction").then((res) => {
        if (res.code == 0) {
          this.listQuery.nf = this.user.year;
          this.getList();
        }
      });
    } else {
      this.listQuery.nf = this.user.year;
      this.getList();
    }
    this.getCourseSumFun();
    //课题属性
    getDictData("pmp_course_group", 1).then((res) => {
      if (res.code === 0) {
        this.ktsxOptions = res.data;
      }
    });
    //年份
    getCourseQueryCondition({ type: 5 }).then((res) => {
      if (res.code === 0) {
        this.nfOptions = res.data;
      }
    });
    //归属部门
    getCourseQueryCondition({ type: 1 }).then((res) => {
      if (res.code === 0) {
        this.bmOptions = res.data;
      }
    });
    //评委委员
    getCourseQueryCondition({ type: 2 }).then((res) => {
      if (res.code === 0) {
        this.pswyOptions = res.data;
      }
    });
    //导师
    getCourseQueryCondition({ type: 3 }).then((res) => {
      if (res.code === 0) {
        this.ktdsOptions = res.data;
      }
    });
    //课题负责人
    getCourseQueryCondition({ type: 4 }).then((res) => {
      if (res.code === 0) {
        this.fzrOptions = res.data;
      }
    });
  },
  methods: {
    handleClick(tab, event) {
      this.listQuery.nf = this.user.year;
      this.getList();
    },
    getCourseSumFun() {
      //课题统计
      getCourseSum().then((res) => {
        if (res.code === 0) {
          if (res.code === 0) {
            this.courseSum.qb = res.data.qb;
            this.courseSum.dwps = res.data.dwps;
            this.courseSum.wyps = res.data.wyps;
            this.courseSum.wcy = res.data.wcy;
            this.courseSum.wfd = res.data.wfd;
          }
        }
      });
    },
    getList() {
      this.zqjcFormDialog = false;
      this.zqjcpsFormDialog = false;
      this.handleLxpsDialog = false;
      this.handleLxpsSecondDialog = false;
      this.addCourseDialog = false;
      this.handleKtcxDialog = false;
      this.handleZlpfDialog = false;
      this.lxsqFormDialog = false;
      this.jxsqFormDialog = false;
      this.yqjxFormDialog = false;
      this.yqjxsqFormDialog = false;
      this.jxpsFormDialog = false;
      this.jxcsFormDialog = false;
      this.yqjxpsFormDialog = false;
      let pswy = this.listQuery.pswy ? this.listQuery.pswy.join(",") : null;
      let fzr = this.listQuery.fzr ? this.listQuery.fzr.join(",") : null;
      let ktds = this.listQuery.ktds ? this.listQuery.ktds.join(",") : null;
      const params = { ...this.listQuery, pswy, fzr, ktds };
      this.getCourseSumFun();
      this.$store
        .dispatch("course/fetchCourseListAction", params)
        .then((res) => {
          if (res.code == 0) {
            const docH = document.documentElement.clientHeight;
            const mycontainerH =
              document.querySelector(".mycontainer").clientHeight;
            this.defaulContainerH = mycontainerH;
            this.height = docH - mycontainerH - 210;
          }
        });
    },
    handleExport() {
      //导出
      let pswy = this.listQuery.pswy ? this.listQuery.pswy.join(",") : null;
      let fzr = this.listQuery.fzr ? this.listQuery.fzr.join(",") : null;
      let ktds = this.listQuery.ktds ? this.listQuery.ktds.join(",") : null;
      const params = { ...this.listQuery, pswy, fzr, ktds };
      exportCourse(params).then((res) => {
        if (res.code === 0) {
          const fileName = res.msg.substr(
            res.msg.indexOf("_") + 1,
            res.msg.length
          );
          const filePath = res.msg;
          const url =
            window.g.apiUrl +
            "system/downloadFile?fileName=" +
            fileName +
            "&filePath=" +
            filePath;
          // 组装a标签
          const elink = document.createElement("a");
          // 设置下载文件名
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = url;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },
    reset() {
      // 重置
      this.listQuery = {
        ...this.listQuery,
        ...{
          type: "0",
          ktsx: null,
          zsls: null,
          nf: null,
          gsbm: null,
          ssjd: null,
          sfcx: null,
          sflx: null,
          sfjx: null,
          pswy: null,
          ktds: null,
          fzr: null,
          ktmc: null,
        },
      };
    },
    handleAddCourse(type) {
      this.addCourseDialog = true;
      type == 1
        ? (this.addCourseTitle = "临时课题录入")
        : (this.addCourseTitle = "管理员课题录入");
      this.mxParams.addCourseType = type;
    },
    handleToLxsq(row) {
      this.lxsqFormDialog = true;
      this.mxParams = row;
    },
    handleToLxps(row) {
      this.handleLxpsDialog = true;
      this.mxParams = row;
    },

    handleToLxpsSecond(row) {
      this.handleLxpsSecondDialog = true;
      this.mxParams = row;
    },
    handleView(row) {
      this.handleResultDialog = true;
      this.mxParams = row;
    },
    hideResultDialog() {
      this.handleResultDialog = false;
      this.getList();
    },
    handleToZqjc(row) {
      this.zqjcFormDialog = true;
      this.mxParams = row;
    },
    handleToZqjcps(row) {
      this.zqjcpsFormDialog = true;
      this.mxParams = row;
      this.mxParams.id = row.id;
    },
    handleToJxsq(row) {
      this.jxsqFormDialog = true;
      this.mxParams = row;
    },
    handleToYqjx(row) {
      this.yqjxFormDialog = true;
      this.mxParams = row;
    },

    handleToYqjxsq(row) {
      this.yqjxsqFormDialog = true;
      this.mxParams = row;
    },
    handleToJxps(row) {
      this.jxpsFormDialog = true;
      this.mxParams = row;
    },
    handleToJxcs(row) {
      this.jxcsFormDialog = true;
      this.mxParams = row;
    },

    handleToYqjxps(row) {
      this.yqjxpsFormDialog = true;
      this.mxParams = row;
    },

    saveZqjcForm() {
      this.$refs.zqjcForm.saveForm();
    },
    saveZqjcpsForm() {
      this.$refs.zqjcpsForm.saveForm();
    },

    saveLxpsForm() {
      this.$refs.lxpsForm.saveForm();
    },
    saveLxpsSecondForm() {
      this.$refs.lxpsSecondForm.saveForm();
    },

    saveKtcxForm() {
      this.$refs.ktcxForm.saveForm();
    },
    saveJxsqForm() {
      this.$refs.jxsqForm.saveForm();
    },
    saveYqjxForm() {
      this.$refs.yqjxForm.saveForm();
    },
    saveJxpsForm() {
      this.$refs.jxpsForm.saveForm();
    },
    saveJxcsForm() {
      this.$refs.jxcsForm.saveForm();
    },
    saveYqjxpsForm() {
      this.$refs.yqjxpsForm.saveForm();
    },
    saveYqjxsqForm() {
      this.$refs.yqjxsqForm.saveForm();
    },
    delKtcxForm() {
      this.$refs.ktcxForm.delApply();
    },

    saveZlpfForm() {
      this.$refs.zlpfForm.saveForm();
    },

    handleToZlpf(row) {
      this.handleZlpfDialog = true;
      this.mxParams = row;
    },

    handleToKtcx(id) {
      this.mxParams = {
        courseId: id,
      };
      isCancelApply({ courseId: id }).then((res) => {
        if (res.code === 0) {
          this.isCancelApply = res.data;
        }
      });

      this.handleKtcxDialog = true;
    },

    saveAddCourseForm() {
      this.$refs.addCourseForm.saveForm();
    },
    saveLxsqForm() {
      this.$refs.lxsqForm.saveForm();
    },
    handletrackMonth(courseId) {
      this.OpenTrackMonth = true;
      this.$nextTick(() => {
        this.$refs.trackMonthRef.init(courseId);
      });
    },
    handleToggleAeraStatus() {
      if (this.areaStatus == 1) {
        this.areaStatus = 0;
      } else {
        this.areaStatus = 1;
      }
      setTimeout(() => {
        const docH = document.documentElement.clientHeight;
        const mycontainerH =
          document.querySelector(".mycontainer").clientHeight;
        this.height = docH - mycontainerH - 210;
      }, 0);
    },
  },
};
</script>
<style lang="less" scoped>
.flex-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5%;
}
.choice-box {
  border: 1px solid;
  border-color: #cccc;
  display: auto;
}
.app-container {
  padding: 10px;
  .dialog-footer {
    text-align: right;
    button {
      margin-left: 30px;
    }
  }
}
.red_label {
  color: #ff0000 !important;
  border-color: #fff !important;
  background-color: #fff;
}
.grey {
  color: #606266 !important;
  border-color: #fff !important;
  background-color: #fff;
}
.grey2 {
  color: #999 !important;
  border-color: #fff !important;
  background-color: #fff;
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
}
.mycontainer .el-form-item {
  margin-bottom: 5px;
}
.filter-container {
  background-color: #fff;
  padding: 0;
}
.filter-container .filter-item {
  margin-bottom: 0;
}
.search-container {
  border: 0;
}
.btn-container {
  padding-top: 0px;
  margin-top: 10px;
  background-color: #f2f2f2;
  border-top: #e2e2e2 1px solid;
  border-left: #e2e2e2 1px solid;
  border-right: #e2e2e2 1px solid;
}

.dialog-header {
  background-color: #f2f2f2;
  margin: 5px 5px;
}
.btn {
  display: block;
  margin: 10px 10px;
  width: 120px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.avatar {
  display: block;
  width: 60px;
  margin: 10px 10px;
}
// .el-button + .el-button {
//   margin-left: 0px;
// }
.el-input__inner {
  width: 100%;
}

.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.flex-item1 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.flex-item2 {
  width: 80px;
  height: 70px;
}
.flex-item3 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.el-table__row > td {
  border: none;
}
.el-table::before {
  height: 0px;
}
.el-table th.is-leaf,
.el-table td {
  border-bottom: 0px;
}

::v-deep .el-dialog {
  width: 64%;
}
::v-deep .el-transfer-panel {
  width: 263px;
}
.pagination-container {
  border: none;
}
::v-deep #save-form .el-form-item__label {
  width: 150px !important;
}
::v-deep #save-form .el-form-item__content {
  margin-left: 150px !important;
}
::v-deep #save-form .el-select {
  width: 100% !important;
}

#save-form .el-form-item {
  margin-bottom: 20px;
}
.row {
  margin-top: 15px;
  .title {
    height: 44px;
    background-color: #d7d7d7;
    padding-left: 15px;
    font-size: 16px;
    line-height: 44px;
    margin-bottom: 15px;
  }
  .step-wrap {
    padding: 0 10%;
  }
  .apply-info {
    display: flex;
    height: 44px;
    line-height: 44px;
    .item {
      padding: 0 50px;
    }
    div {
      display: flex;
    }
  }
}
.myRadio {
  margin-right: 5px;
}
.gray {
  background-color: #ddd;
  border-color: #ddd;
}
::v-deep .list_judges {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
